module.exports = __webpack_public_path__ + "img/tu08.1eca578d.png";